import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import type { FallbackProps } from 'react-error-boundary';

/** ErrorFallback */
function ErrorFallback({ error }: FallbackProps) {
  // eslint-disable-next-line no-console
  console.error(error);
  return (
    <Dialog
      open
    >
      <DialogTitle>
        予期せぬエラーが起きました
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          予期せぬエラーが起きました。
          改善のため、この現象は開発者にレポートされます。
          お手数をおかけし恐縮ですが、ブラウザのリロードにより再起動をお願いします。
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
export default ErrorFallback;
